import PropTypes from 'prop-types';
import React from 'react';
import I18n from 'apps/new-web/views/components/i18n';
import Image from 'apps/new-web/views/components/image';
import MuiButton from '@material-ui/core/Button';
import ProgressHeader from '../progress-header';
import ActivateTimer from '../activate-timer';

const strong = { strongBegin: '<strong>', strongEnd: '</strong>' };

const ActivateConsole = ({ showHeader, showButton, navigate, nextRoutes }) => {
  return (
    <section className="activate-console-page">
      {showHeader && (
        <ProgressHeader sectionNumber={ 4 } pageNumber={ 2 } />
      )}
      <h1><I18n desc="Tells the user to begin the first step of activating their machine.">Activate your machine</I18n></h1>
      <div className="activate-step-paper">
        <div className="activate-step-content">
          <section className="step-one-content">
            <h2><I18n desc="Tells the user to locate the bluetooth button on their machine." args={ strong }>[strongBegin]Step 1.[strongEnd] Locate one of these buttons on your console:</I18n></h2>
            <Image className="step-icons hide-on-mobile" src={ '/onboarding/activate/img/step-icons.svg' } alt={ I18n.translate('Examples of possible [bluetooth] buttons on your machine', { 'bluetooth': 'Bluetooth' }) } />
            <Image className="step-icons-mobile hide-on-desktop hide-on-tablet" src={ '/onboarding/activate/img/step-icons-mobile.svg' } alt={ I18n.translate('Examples of possible [bluetooth] buttons on your machine', { 'bluetooth': 'Bluetooth' }) } />
            <span className="common"><I18n desc="Lable indicating the most common Bluetooth label.">Most common</I18n></span>
          </section>
          <div className="activate-step-timer">
            <ActivateTimer time={ 30 } gradientColors={ [{ key: 'col0', stopColor: '#8B68FA', offset: '0%' }, { key: 'col1', stopColor: '#3F7DED', offset: '100%' }] } />
            <p>
              <I18n
                desc="Tells the user to press and hold the bluetooth button."
                args={ strong }
              >
                  Press and hold the button for [strongBegin]30 seconds[strongEnd].
              </I18n>
            </p>
          </div>
          <div className="activate-step-disclaimer">
            <p><I18n args={ strong } desc="Warning to insert safety key before proceeding to the next activation step.">[strongBegin]Important:[strongEnd] If you have a treadmill, please make sure your safety key is plugged in before proceeding to the next step. [strongBegin]The belt will begin moving during activation.[strongEnd]</I18n></p>
            <p><I18n desc="Information about the machine flashing while holding button.">Your console may flash or beep while holding. Continue to hold for the full 30 seconds.</I18n></p>
          </div>
          <section className="step-two-content">
            <h2><I18n args={ strong }>[strongBegin]Step 2.[strongEnd] Start using your machine to make sure it is activated.</I18n></h2>
            <p className="having-trouble">
              <I18n args={ strong }>Having issues? Try repeating [strongBegin]Step 1.[strongEnd]</I18n>
            </p>
          </section>
          <div className="activate-step-instructions">
            <p>
              <I18n args={ strong }>[strongBegin]For treadmills:[strongEnd] Press the Start button. Once your treadmill belt starts moving, you have successfully activated your machine.</I18n>
            </p>
            <p>
              <I18n args={ strong }>[strongBegin]For bikes, ellipticals, and other smart equipment:[strongEnd] Once you see metrics appear on your console, you have successfully activated your machine.</I18n>
            </p>
            <p className="last-step"><I18n>You're all set!</I18n></p>
          </div>
        </div>
      </div>
      <div className="activate-step-buttons clearfix">
        {showButton && (
          <MuiButton
            className="activate-step-next"
            variant="contained"
            color="primary"
            onClick={ navigate(nextRoutes.default) }
            fullWidth="true"
            style={{ height: '60px', marginTop: '15px' }}
          >
            <I18n desc="Button that invites the user to proceed to the next page.">Next</I18n>
          </MuiButton>
        )}
      </div>
      <div className="live-chat">
        <I18n
          args={{ strongBegin: '<strong>', strongEnd: '</strong>', phone: '1-866-608-1798', space: '&nbsp;', break: '<br class="hide-on-desktop hide-on-tablet" />', phoneLinkStart: '<a href="tel:1-866-608-1798">', phoneLinkEnd: '</a>' }}
          desc="Sentence fragment inviting users to call iFIT'\s help line."
        >
            Have questions?[space][break] Call [phoneLinkStart][strongBegin][phone][strongEnd][phoneLinkEnd][space]or[space]
        </I18n>
        <a href="https://my.ifit.com/MC/s/article/1407" target="_blank">
          <I18n desc="Sentence fragment describing iFIT\'s live support.">
              LIVE CHAT.
          </I18n>
        </a>
      </div>
    </section>
  );
};

ActivateConsole.propTypes = {
  isRegistered: PropTypes.bool,
  showHeader: PropTypes.bool,
  showButton: PropTypes.bool,
  navigate: PropTypes.func.isRequired,
  nextRoutes: PropTypes.object.isRequired
};

ActivateTimer.defaultProps = {
  isRegistered: false,
  showHeader: true,
  showButton: true
};

export default ActivateConsole;
